// Seller / Member-as-Vendor dummy data
export const sellerStore = {
  storeName: "Catering Annisa",
  bio: "Catering rumahan halal, masakan tradisional sejak 2019.",
  logo: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&q=80",
  banner: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=1200&q=80",
  rating: 4.9,
  reviewCount: 312,
  totalSales: 1240,
  joinedAt: "2022-03-14",
  verified: true,
  pendingPayout: 4280000,
  lifetimeRevenue: 38400000,
};

export const sellerProducts = [
  { id: "sp1", name: "Nasi Box Ayam Bakar (per box)", category: "Catering", price: 28000, stock: 200, image: "https://images.unsplash.com/photo-1567337710282-00832b415979?w=600&q=80", status: "Aktif", sold: 420, rating: 4.9 },
  { id: "sp2", name: "Bolu Pisang Original 500g", category: "Kue & Roti", price: 45000, stock: 32, image: "https://images.unsplash.com/photo-1565538810643-b5bdb714032a?w=600&q=80", status: "Aktif", sold: 198, rating: 4.8 },
  { id: "sp3", name: "Sambal Ijo Khas Padang 200ml", category: "Bumbu Siap", price: 18000, stock: 8, image: "https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=600&q=80", status: "Stok Rendah", sold: 156, rating: 4.7 },
  { id: "sp4", name: "Tumpeng Mini Komplit (4 porsi)", category: "Catering", price: 185000, stock: 12, image: "https://images.unsplash.com/photo-1607301406259-dfb186e15de8?w=600&q=80", status: "Aktif", sold: 64, rating: 5.0 },
  { id: "sp5", name: "Keripik Singkong Original 250g", category: "Snack", price: 22000, stock: 0, image: "https://images.unsplash.com/photo-1599490659213-e2b9527bd087?w=600&q=80", status: "Habis", sold: 320, rating: 4.6 },
];

export const sellerOrders = [
  { id: "SO-2026-0142", buyer: "Bima Setiawan", buyerType: "Anggota", items: 3, total: 84000, status: "Baru", date: "2026-02-08" },
  { id: "SO-2026-0141", buyer: "Tamu — Andi P.", buyerType: "Tamu", items: 1, total: 28000, status: "Diproses", date: "2026-02-08" },
  { id: "SO-2026-0140", buyer: "Gita Larasati", buyerType: "Anggota", items: 2, total: 90000, status: "Dikirim", date: "2026-02-07" },
  { id: "SO-2026-0139", buyer: "Tamu — Rina S.", buyerType: "Tamu", items: 4, total: 112000, status: "Selesai", date: "2026-02-06" },
  { id: "SO-2026-0138", buyer: "Hendra Wijaya", buyerType: "Anggota", items: 1, total: 185000, status: "Selesai", date: "2026-02-05" },
];

export const sellerRevenue = [
  { d: "Sen", v: 240 }, { d: "Sel", v: 320 }, { d: "Rab", v: 280 },
  { d: "Kam", v: 410 }, { d: "Jum", v: 520 }, { d: "Sab", v: 680 }, { d: "Min", v: 380 },
];

// Public order tracker
export const publicOrderTrack = {
  id: "ORD-202602-0142",
  buyerName: "Andi Pratama (Tamu)",
  date: "2026-02-08",
  total: 287000,
  items: [
    { name: "Beras Premium Pandan Wangi 5kg", qty: 2, price: 78000 },
    { name: "Madu Hutan Murni 500ml", qty: 1, price: 120000 },
    { name: "Gula Aren Organik 500g", qty: 1, price: 22000 },
  ],
  payment: "QRIS",
  shipping: "JNE REG",
  tracking: "JNE 9281731",
  eta: "2026-02-11",
  currentStatus: "Dikirim",
  timeline: [
    { status: "Pesanan Dibuat", time: "08 Feb · 09:14", done: true },
    { status: "Pembayaran Diterima", time: "08 Feb · 09:18", done: true },
    { status: "Dikemas oleh Koperasi", time: "08 Feb · 14:22", done: true },
    { status: "Diserahkan ke Kurir", time: "09 Feb · 08:10", done: true },
    { status: "Dikirim (dalam perjalanan)", time: "09 Feb · 11:30", done: true, active: true },
    { status: "Diterima", time: "Estimasi 11 Feb", done: false },
  ],
};
